import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { guaranteeBadges } from '../data/content';
export function Guarantee() {
  return <section className="w-full bg-sand py-16 sm:py-20" aria-labelledby="guarantee-heading" data-id="element-136" data-mp="1o33y2s436cn1">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-137" data-mp="222whs3h73sli">
        <p className="font-sans text-xs font-bold uppercase tracking-[0.24em] text-gold" data-id="element-138" data-mp="1x3tothehpctw">
          Zero risk · 100% protected
        </p>
        <div className="mx-auto mt-6 flex h-16 w-16 items-center justify-center rounded-full bg-gold text-espresso" data-id="element-139" data-mp="19fadet058jxl">
          <ShieldCheckIcon className="h-8 w-8" aria-hidden="true" data-id="element-140" data-mp="14dl2regu28a1" />
        </div>
        <h2 id="guarantee-heading" className="mt-6 font-display text-3xl font-semibold leading-tight tracking-tight text-espresso sm:text-4xl" data-id="element-141" data-mp="1j6501yhaxljk">
          7-day money-back guarantee
        </h2>
        <p className="mx-auto mt-5 max-w-prose font-sans text-base leading-relaxed text-cocoa" data-id="element-142" data-mp="qm6kxaynwd4k">
          Open everything. Use the vendor list. Try the techniques on real hair. If The
          Braid &amp; Gloss Bible doesn&rsquo;t change how you work and what you charge,
          we refund every dollar — no questions asked.
        </p>

        <ul className="mt-8 flex flex-wrap justify-center gap-3" data-id="element-143" data-mp="yp2v5rvg58l2">
          {guaranteeBadges.map(badge => <li key={badge} className="rounded-full border border-espresso/15 bg-cream px-4 py-2 font-sans text-[11px] font-bold uppercase tracking-[0.12em] text-cocoa" data-id="element-144" data-mp="12pv6qrrsjpki">
              {badge}
            </li>)}
        </ul>
        <p className="mt-6 font-display text-lg font-semibold text-gold" data-id="element-145" data-mp="f0u4jm9jxano">
          Satisfaction guaranteed, or your money back.
        </p>
      </div>
    </section>;
}